/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Rail_AccountInputs */

const en_start_page_rail_account = /** @type {(inputs: Start_Page_Rail_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const pl_start_page_rail_account = /** @type {(inputs: Start_Page_Rail_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Start_Page_Rail_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_rail_account = /** @type {((inputs?: Start_Page_Rail_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Rail_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_rail_account(inputs)
	return en_start_page_rail_account(inputs)
});